import { ButtonHTMLAttributes } from "react";
type Props = ButtonHTMLAttributes<HTMLButtonElement> & { variant?: "primary" | "secondary" };
export default function Button({ variant = "primary", className = "", ...props }: Props) {
  const base = "inline-flex items-center justify-center rounded-xl px-5 py-2.5 text-sm font-semibold transition focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-[#f7f2ea]";
  const styles = variant === "primary"
    ? "bg-[#1a2a22] text-[#f7f2ea] shadow-[0_18px_40px_-24px_rgba(14,24,18,0.9)] hover:-translate-y-0.5 hover:bg-[#223629] focus:ring-[#1a2a22]"
    : "bg-white text-[#1a1c18] ring-1 ring-black/10 hover:-translate-y-0.5 hover:bg-[#f1ebe2] focus:ring-black/30";
  return <button className={`${base} ${styles} ${className}`} {...props} />;
}
